/* ------------------------------------------------------------------
// 会員登録フォーム、応募フォームのスパム対策用ダミーフィールド設定
--------------------------------------------------------------------- */
function setDummyFormValue(selector = ".jsDummy", value = "7hs4sk2") {
  document.querySelectorAll(selector).forEach((element) => {
    element.value = value;
  });
}

// NOTE: エントリポイントからのグローバル参照に対応するため window に公開
window.setDummyFormValue = setDummyFormValue;

export default setDummyFormValue;